let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eXs8q")).then(() => parcelRequire('3im4v'));